<template>
  <div class="">
      <Widget>
        <h3>Previous <span class="fw-semi-bold">Payments</span></h3>
        <p>
          History for doctor payments
        </p>
        <div class="table-responsive">
          <table class="table table-lg mb-0 requests-table table-hover">
            <thead>
            <tr class="text-muted">
              <th width="20%"><span class="fw-bold">Date</span></th>
              <th width="20%"><span class="fw-bold">Amount</span></th>
              <th width="15%"><span class="fw-bold">Action(s)</span></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="payment in payments" :key="payment.id">
              <td>{{ convertToDateString(payment.date) }}</td>
              <td>{{ payment.amount }}</td>
              <td>
                <b-button variant="outline-success" class="fa fa-download" size="sm"> paycheck
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
        <b-pagination
            v-model="currentPage"
            :total-rows="tableRows"
            :per-page="perPage"
            first-number
            @input="loadPayments"
        ></b-pagination>
      </Widget>
  </div>
</template>

<script>

// import historymock from "@/pages/doctor/History/historymock";
import PaymentService from '@/services/doctor/payments.service';

export default {

  name: "PaymentsHistory",
  props: ['doctor'],
  data() {
    return {
      // historymock
      currentPage: 1,
      tableRows: 100,
      perPage: 5,
      payments: []
    };
  },
  computed: {

  },
  methods: {
    loadPayments() {
      PaymentService.fetchDoctorPayments(this.doctor.id, this.currentPage)
          .then((response) => {
            if (response.status === 200) {
              this.perPage = response.data.per_page;
              this.tableRows = response.data.total;
              this.payments = response.data.data;
            }
          })
    },
    convertToDateString(date){
      return new Date(date).toDateString();
    },
    // downloadCheckupPrescription(checkupprescription_id) {
    //   AppointmentService.fetchCheckupPrescriptionFile(checkupprescription_id)
    //       .then(response => {
    //         if (response.status === 200) {
    //           let blob = new Blob([response.data], {type: 'application/pdf'})
    //           let link = document.createElement('a')
    //           link.href = window.URL.createObjectURL(blob)
    //           link.download = 'test.pdf'
    //           link.click()
    //         }
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    // }
  },
  mounted() {
    this.loadPayments();
  }
}

</script>

<style scoped>

</style>
